import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import React from 'react';
import styled from 'styled-components';

import { FontSize } from '../theme/FontSize';
import { Rounded } from '../theme/Rounded';
import { Spacing } from '../theme/Spacing';
import { AtiraIcon } from './AtiraIcon';
import { Flex } from './Flex';
import { Text } from './Text';

type InfoProps = {
  info: React.ReactNode;
  className?: string;
};

const Banner = styled(Flex)`
  position: relative;
  z-index: 1;
  padding: ${Spacing.s} ${Spacing.m};
  border-radius: ${Rounded.md};
  align-items: center;
  gap: ${Spacing.s};
  background: ${({ theme }) => theme.main}20;
  width: 100%;
`;

const StyledText = styled(Text)`
  color: ${({ theme }) => theme.main};
  font-size: ${FontSize.s};
  width: 100%;
`;

export const InfoNotice: React.FC<InfoProps> = ({ info, className }) => {
  return (
    <Banner className={className}>
      <AtiraIcon icon={faInfoCircle} color="main" />
      <StyledText fontSize="s" color="main">
        {info}
      </StyledText>
    </Banner>
  );
};
